import React, { FC, useEffect, useState } from 'react';
import Header from "../../sections/Header"

import { setSuccess } from '../../../store/actions/userActions';
import { RootState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';

import imgWidgetPreview from '../../../assets/images/success/widget.png'
import copyToClipBoard from '../../../assets/images/dashboard/copy-to-clipboard.png'

import "../../css/Success.css"
import { Link } from 'react-router-dom';
import queryString from 'query-string'
import { base_url_widget, getEnvAccordingToHostName, nameOfWidget } from '../../../utils/env';
import { getRequestParams, service } from '../../../tools/service';


const SuccessWidget: FC = () => {
  const {  success } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const[widgetId,setWidgetId] = useState("");
  const[companyId,setCompanyId] = useState("");
  const[masterId,setMasterId] = useState("")
  useEffect(()=>{
    const urlValues = queryString.parse(window.location.search)
    setWidgetId(urlValues.widgetId as string ?? "")
    setCompanyId(urlValues.companyId as string ?? "")
    getMasterId()
  },[])
  useEffect(() => {
    if (success) {
      dispatch(setSuccess(''));
    }
  }, [success, dispatch]);
  let selectedEnv = '';
  let environment = getEnvAccordingToHostName();
  if(environment.includes('-')) {
    selectedEnv = environment.substring(1);  //environments are listed as -[dev|qa|uat]; prod is ''
  }
  function  getMasterId() {
    const temp = getRequestParams() as any
    let data = {} as any
    data["masterId"] = temp.masterId
    service.post(`/api/masterId/decrypt`,data)
    .then(response => {
      setMasterId(response.data.masterId)
    })
}
  return (
    <>
      <Header />
      <div className="h-screen w-full  bg-customGray flex flex-col ">
        <div className=" justify-center  max-w-5xl flex-row md:flex lg:ml-60 mb-3 mt-10">
          <div className="md:w-1/2 mb-10 flex md:flex-col">
            <p className="sucess-p text-customBlue">Success!</p>
            <p className="your-widget-p mt-3">
              Your widget has been created successfully, on the right is a preview of your final product.
              Below you will find the code, just copy and paste onto your website and you’re all set to start
              receiving appointments.
            </p>
            <div className=" md:w-2/3  relative code-snippet box-shadow mt-4">
              <p className="text-md your-code-snippet"  >
                &lt;script 
                  id=&quot;successware-customer-link-widget&quot;
                  env=&quot;{selectedEnv}&quot;
                  companyId=&quot;{companyId}&quot;
                  widgetId=&quot;{widgetId}&quot;
                  masterId=&quot;{masterId}&quot;
                  src=&quot;{base_url_widget}widget/{nameOfWidget}?v=1.0.0&quot;&gt; 
                &lt;/script&gt;
                </p>
            </div>
            <div className="md:w-1/4  mt-4">
              <Link to="/admin/widget">
                <button
                  className="font-bold text-customBlue custom-btn-add-service"
                >OK</button>
              </Link>
            </div>

          </div>
          <div className="md:w-1/2 md:ml-4">
            <img src={imgWidgetPreview} alt="Example of a widget" />
          </div>
        </div>
      </div>
    </>
  )
}

export default SuccessWidget;
